import { Navigate, useOutletContext } from 'react-router-dom'

import {
  CompetenciesProfileRootPageDocument,
  CompetenciesProfileRootPageQuery,
} from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/competencies/lib/ProfileCollectionsBootstrap'
import Competencies from 'modules/competencies/pages/employees/Competencies'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { RouteContext } from 'modules/profile/pages/RootPage'

interface ContainerProps {
  data?: CompetenciesProfileRootPageQuery
}

const Container = ({ data }: ContainerProps) => {
  const { navigation } = useNavigation()
  const { competenciesAvailable } = useOutletContext<RouteContext>()

  const canManageCompetencies = data?.competencies._policies.competenciesManage.can ?? false

  if (!competenciesAvailable && canManageCompetencies)
    return <Navigate replace to={navigation.discover.marketplaceModules.fullPath()} />

  if (!competenciesAvailable) return <NotFound />

  return <Competencies assessmentGroups={data?.competencies.assessmentGroups} />
}

const RootPage = () => {
  const { employee } = useOutletContext<RouteContext>()

  const { loading, data, error } = useQuery(CompetenciesProfileRootPageDocument, {
    variables: {
      targetEmployeeIds: [employee.id.toString()],
    },
  })

  return (
    <ResponsivePage.Body loading={loading} error={error} variant="full">
      <CollectionsBootstrap>
        <Container data={data} />
      </CollectionsBootstrap>
    </ResponsivePage.Body>
  )
}

export default RootPage
